import {
  HeroConversationMessage,
  useAppSelector,
  chatSelectors,
  useGetTwilioConversationMessageMediaUrl,
} from '@vs-online-only-app/state';
import useSelectedConversationPaginatedMessages from './useSelectedConversationPaginatedMessages';
import { Message } from '@twilio/conversations';
import { useSelectedHeroConversation } from './useSelectedHeroConversation';

const useConversationMessage = (message: HeroConversationMessage) => {
  const heroConversation = useSelectedHeroConversation();
  const localConversationMessages = useAppSelector((state) =>
    chatSelectors.selectLocalMessagesByConversationId(
      state,
      message.conversation.sid
    )
  );

  const isLocal = Boolean(
    localConversationMessages?.find(
      (localMessage) => localMessage.sid === message.sid
    )
  );

  const { data: twilioMediaUrl } = useGetTwilioConversationMessageMediaUrl(
    message as HeroConversationMessage & Message,
    isLocal
  );

  const { allMessages } = useSelectedConversationPaginatedMessages();

  const isCustomerMessage =
    heroConversation?.conversationStarter.username === message.author;

  const messageIndex = allMessages.findIndex(
    (currentMessage) => currentMessage.sid === message.sid
  );

  const nextMessage = allMessages?.[messageIndex + 1];
  const prevMessage = allMessages?.[messageIndex - 1];

  const variant = isCustomerMessage ? 'incoming' : 'outgoing';
  const isNextMessageSentBySameAuthor = nextMessage?.author === message.author;
  const isPrevMessageSentBySameAuthor = prevMessage?.author === message.author;
  const isPrevAndNextMessagesSentBySameAuthor =
    isNextMessageSentBySameAuthor && isPrevMessageSentBySameAuthor;

  const isFirstInStack =
    !isPrevMessageSentBySameAuthor && isNextMessageSentBySameAuthor;
  const isLastInStack =
    isPrevMessageSentBySameAuthor && !isNextMessageSentBySameAuthor;

  const isStacked =
    isPrevAndNextMessagesSentBySameAuthor || isFirstInStack || isLastInStack;

  return {
    variant,
    isAssociateMessage: !isCustomerMessage,
    isFirstInStack,
    isLastInStack,
    isStacked,
    isLocal,
    mediaUrl: isLocal ? message.attributes.mediaUrl : twilioMediaUrl,
  };
};

export default useConversationMessage;
